import axios from "../../api";

export const playerSearchWithMetaRatings = (
  name: string,
  currentPage: number,
  platform: string,
  playerRoleId?: number,
  evolutions?: boolean,
) =>
  axios.post(
    "/players/search",
    {
      searchText: name,
      page: currentPage,
      platform,
      playerRoleId,
      evolutions,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
